<template>
  <div
    class="FormField"
    :class="{
      'FormField--hasGridArea': !!gridArea,
    }"
  >
    <component
      :is="isFieldset ? 'fieldset' : 'label'"
      class="FormField__labelContainer"
    >
      <component
        :is="isFieldset ? 'legend' : 'div'"
        class="FormField__label"
      >
        {{ label }}
      </component>
      <slot />
    </component>
  </div>
</template>

<script lang="ts" setup>
const {
  gridArea,
} = defineProps<{
  label: string,
  gridArea?: string,
  isFieldset?: boolean,
}>();
</script>

<style lang="scss" scoped>
.FormField {
  min-width: 0;
}

.FormField--hasGridArea {
  grid-area: v-bind(gridArea);
}

.FormField__labelContainer {
  min-width: 0;
}

.FormField__label {
  margin-bottom: 9px;

  color: var(--themeColorNeutral600);

  font-size: 14px;
  font-weight: var(--fontWeightMedium);
  font-stretch: var(--fontWidthExtended);
  text-align: left;

  [data-theme="dark"] & {
    color: var(--themeLightTransparent700);
  }
}
</style>
